import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { TarifaDetalle } from '../../domain/tarifa-detalle.domain';
import { TarifaDetalleWritePayload } from '../../domain/tarifa-detalle-write.domain';

@Injectable({
  providedIn: 'root'
})
export class TarifaDetalleApiService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl: string = `${environment.URL_API}/tarifa-detalles`;

  updateDetalle(id: number, payload: TarifaDetalleWritePayload): Observable<TarifaDetalle> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/merge-patch+json'
    });
    return this.http.patch<TarifaDetalle>(`${this.apiUrl}/${id}`, payload, { headers });
  }

  createDetalle(payload: TarifaDetalleWritePayload): Observable<TarifaDetalle> {
    return this.http.post<TarifaDetalle>(this.apiUrl, payload);
  }

  deleteDetalle(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}

